<template>
  <div class="vehicle-grid container-fluid" role="region">
    <div class="row">
      <div class="grid-box long-box col-sm-8" id="mustang">
        <div class="text-overlay">
          <span class="text-title">Ford Mustang</span><br />
          <span class="text-body">The legend you can make your own</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box small-box col-sm-4" id="explorer">
        <div class="text-overlay">
          <span class="text-title">Ford Explorer</span><br />
          <span class="text-body">Always unstoppable</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box small-box col-sm-4" id="fusion">
        <div class="text-overlay">
          <span class="text-title">Ford Fusion</span><br />
          <span class="text-body">Turn heads with confidence</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box small-box col-sm-4" id="f-150">
        <div class="text-overlay">
          <span class="text-title">Ford F-150</span><br />
          <span class="text-body">Class-leading capability</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box tall-box col-sm-4" id="expedition">
        <div class="text-overlay">
          <span class="text-title">Ford Expedition</span><br />
          <span class="text-body">For those who do more, together</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box tall-box col-sm-4" id="ecosport">
        <div class="text-overlay">
          <span class="text-title">Ford EcoSport</span><br />
          <span class="text-body">Big upgrade in a small package</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <div class="grid-box small-box col-sm-4 pull-left" id="bronco">
        <div class="text-overlay">
          <span class="text-title">Ford Bronco</span><br />
          <span class="text-body">Personal, inside and out</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>

      <!-- <div class="grid-box tall-box col-sm-4" id="focus">
			<div class="text-overlay">
				<span class="text-title">Ford Focus</span><br>
				<span class="text-body">Equipped to maximize the fun factor</span>
				<a href="#" class="btn">Explore</a>
			</div>
		</div> -->
      <!-- <div class="grid-box small-box col-sm-4" id="c-max">
			<div class="text-overlay">
				<span class="text-title">Ford C-Max</span><br>
				<span class="text-body">As stylish as it is smart</span>
				<a href="#" class="btn">Explore</a>
			</div>
		</div> -->
      <div class="grid-box small-box col-sm-4" id="escape">
        <div class="text-overlay">
          <span class="text-title">Ford Escape</span><br />
          <span class="text-body">For those who live on the go</span>
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <!-- <div class="grid-box small-box col-sm-4" id="flex">
			<div class="text-overlay">
				<span class="text-title">Ford Flex</span><br>
				<span class="text-body">Comfortable even before you're seated</span>
				<a href="#" class="btn">Explore</a>
			</div>
		</div> -->
      <div class="grid-box small-box col-sm-4" id="edge">
        <div class="text-overlay">
          <span class="text-title">Ford Edge</span><br />
          <span class="text-body"
            >Designed to help you feel confident on the road</span
          >
          <a href="#" class="btn">Explore</a>
        </div>
      </div>
      <!-- <div class="grid-box long-box col-sm-8" id="taurus">
			<div class="text-overlay">
				<span class="text-title">Ford Taurus</span><br>
				<span class="text-body">Exudes sophistication and timeless style</span>
				<a href="#" class="btn">Explore</a>
			</div>
		</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["brand"],
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.vehicle-grid .grid-box {
  position: relative;
  background-size: cover;
  background-position: center;
  display: inline-block;
  margin: 0;
}
.vehicle-grid .small-box {
  width: 33.3333333%;
  height: 300px;
}
.vehicle-grid .long-box {
  width: 66.66666666%;
  height: 300px;
}
.vehicle-grid .tall-box {
  width: 33.3333333%;
  height: 600px;
}
.vehicle-grid #mustang {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/450/original/ford_mustang_red.jpg?1542726681);
}
.vehicle-grid #explorer {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/883/original/CFH-Images-101421-2021Explorer_%281%29.jpeg?1634304201);
}
.vehicle-grid #fusion {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/022/534/original/ford-fusion-white-compressor.jpg?1546617722);
}
.vehicle-grid #expedition {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/878/original/CFH-Images-101421-2021Expedition_%281%29.jpeg?1634304116);
  background-position-x: 40%;
}
.vehicle-grid #bronco {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/881/original/CFH-Images-101421-2021Bronco_%281%29.jpeg?1634304117);
}
.vehicle-grid #f-150 {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/879/original/CFH-Images-101421-2021F150_%281%29.jpeg?1634304116);
}
.vehicle-grid #ecosport {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/440/original/ford-ecosport-blue-compressor.jpg?1542726460);
  background-position-x: 70%;
}
.vehicle-grid #focus {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/470/original/ford-focus-blue-compressor.jpg?1542740502);
  background-position-x: 60%;
}
.vehicle-grid #c-max {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/439/original/ford-c-max-grey-compressor.jpg?1542726438);
}
.vehicle-grid #escape {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/880/original/CFH-Images-101421-2021Escape_%281%29.jpeg?1634304116);
}
.vehicle-grid #flex {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/447/original/ford_flex_silver.jpg?1542726616);
}
.vehicle-grid #edge {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/157/882/original/CFH-Images-101421-2022Edge.jpeg?1634304118);
}
.vehicle-grid #taurus {
  background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/021/451/original/ford_taurus_black.jpg?1542726701);
}
.vehicle-grid .text-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  width: 100%;
  height: 34%;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  color: #fff;
  text-align: left;
  padding: 5px 15px;
}
.vehicle-grid .text-title {
  font-size: 30px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.vehicle-grid .text-body {
  font-size: 18px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.vehicle-grid a {
  display: none;
  color: #fff;
  background: transparent;
  border: 2px solid #fff;
  border-radius: 3px;
  text-transform: uppercase;
  padding: 8px 30px;
  font-size: 16px;
  text-align: left;
  margin: 10px 0;
  width: max-content;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.vehicle-grid a:hover {
  color: #333;
  background: #fff;
}
.vehicle-grid .grid-box:hover .text-overlay {
  height: 50%;
}
.vehicle-grid .grid-box:hover a {
  display: block;
}

@media (max-width: 991px) {
  .vehicle-grid .text-overlay {
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .vehicle-grid a {
    display: block;
  }
}
@media (max-width: 767px) {
  .vehicle-grid .tall-box,
  .vehicle-grid .small-box,
  .vehicle-grid .long-box {
    width: 100%;
  }
  .vehicle-grid .tall-box {
    height: 300px;
  }
}
@media (min-width: 768px) {
  .vehicle-grid #ecosport {
    margin-top: -300px;
  }
  .vehicle-grid #bronco {
    margin-top: -300px;
  }
  .vehicle-grid #flex {
    margin-top: -300px;
  }
}
@media (min-width: 992px) {
  .vehicle-grid .tall-box .text-overlay {
    height: 20%;
  }
  .vehicle-grid .tall-box:hover .text-overlay {
    height: 30%;
  }
}
</style>
